import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "2016d236-847a-4a8b-b8e2-d21e9a27dbc6",
    content: "Answer 1",
    options: { image: `${config.ASSETS_URL}/03/03/task/task-1-answer-1.svg` },
  },
  {
    id: "04dfba0f-874c-42ab-8840-fc5cdc523421",
    content: "Answer 2",
    options: { image: `${config.ASSETS_URL}/03/03/task/task-1-answer-2.svg` },
  },
  {
    id: "cbe49e3e-a82c-48f6-b2de-336229fbd914",
    content: "Answer 3",
    options: { image: `${config.ASSETS_URL}/03/03/task/task-1-answer-3.svg` },
  },
  {
    id: "867fa3d9-4a0a-406f-83f1-438b4782038f",
    content: "Answer 4",
    options: { image: `${config.ASSETS_URL}/03/03/task/task-1-answer-4.svg` },
  },
];

export const task: Task = {
  id: "e9337bbb-4b18-4469-aa99-54f8a0e71d2e",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
    imageHeight: 150,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["867fa3d9-4a0a-406f-83f1-438b4782038f"],
};
